// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicSpotGetV2SystemTime (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2SystemStatus (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2MarketOrderbook (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2MarketTrades (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2MarketTicker (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2MarketAllTickers (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2ExExchangeInfo (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2ExCurrencies (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2MarketKlines (params?: {}): Promise<implicitReturnType>;
    publicSpotGetV2ExTradefees (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1SystemTime (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1SystemStatus (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1ExchangeTradefee (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1ExchangeTradefees (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1MarketOrderBook (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1MarketTicker24Hr (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1MarketMarkets (params?: {}): Promise<implicitReturnType>;
    publicSwapGetV1MarketAggTrade (params?: {}): Promise<implicitReturnType>;
    publicSwapPostV1MarketKlines (params?: {}): Promise<implicitReturnType>;
    privateSpotPostV2ExOrders (params?: {}): Promise<implicitReturnType>;
    privateSpotGetV2ExOrders (params?: {}): Promise<implicitReturnType>;
    privateSpotGetV2AccountBalance (params?: {}): Promise<implicitReturnType>;
    privateSpotGetV2ExTradefee (params?: {}): Promise<implicitReturnType>;
    privateSpotGetV2ExOrder (params?: {}): Promise<implicitReturnType>;
    privateSpotGetV2ExOrderFills (params?: {}): Promise<implicitReturnType>;
    privateSpotDeleteV2ExOrder (params?: {}): Promise<implicitReturnType>;
    privateSpotDeleteV2ExOrders (params?: {}): Promise<implicitReturnType>;
    privateSpotDeleteV2ExOrdersCancelAll (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1WalletBalance (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1TradeOrder (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1TradeOrderOpenOrders (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1TradeUserLeverages (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1TradeUserLeverage (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1TradePositions (params?: {}): Promise<implicitReturnType>;
    privateSwapGetV1TradeHistory (params?: {}): Promise<implicitReturnType>;
    privateSwapPostV1TradeOrder (params?: {}): Promise<implicitReturnType>;
    privateSwapPostV1TradeOrderAddTPSL (params?: {}): Promise<implicitReturnType>;
    privateSwapPostV1TradeAddMargin (params?: {}): Promise<implicitReturnType>;
    privateSwapPostV1TradeReduceMargin (params?: {}): Promise<implicitReturnType>;
    privateSwapPostV1TradePositionClose (params?: {}): Promise<implicitReturnType>;
    privateSwapPostV1TradeUpdateUserLeverage (params?: {}): Promise<implicitReturnType>;
    privateSwapDeleteV1TradeOrder (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
